import type { CSSProperties } from 'react';
import { cn } from '../../lib/utils.ts';

type SkeletonProps = {
    className?: string;
    style?: CSSProperties;
};

export function Skeleton({ className, style }: SkeletonProps) {
    return (
        <div
            aria-hidden="true"
            className={cn(
                'h-3.5 animate-shimmer rounded bg-gray-100 bg-[linear-gradient(105deg,#f3f4f6_30%,#eceef0_50%,#f3f4f6_70%)] bg-[length:200%_100%] motion-reduce:animate-none',
                className,
            )}
            style={style}
        />
    );
}
